import { DocumentLinks } from "@frec-js/common";
import { FC } from "react";

import { Button } from "../../components/Button";
import { TextLink } from "../../components/Link";
import { BrokerageWebPath } from "../../utils/paths";

export const ZeroCommissionTrading: FC = () => {
  return (
    <section className="bgZeroCommission grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[96px_auto_96px]">
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v flex flex-col items-center gap-8 px-6 lg:mx-12 lg:border-x lg:px-16">
        <h2 className="text-center">Zero commission trading</h2>
        <div>
          <p className="lg:text-20 px-6 text-center">
            Like other brokerages, you can invest in stocks and ETF trades
            commission-free.
          </p>
          <p className="lg:text-20 px-6 text-center">$0 to get started.</p>
        </div>
        <Button onClick={() => (location.href = BrokerageWebPath.signup)}>
          Get started
        </Button>
        <TextLink
          className="mx-auto w-fit text-[14px] opacity-70"
          href={DocumentLinks["Frec’s Pricing & Fee Schedule"]}
          target="_blank"
        >
          See a full list of our fees here
        </TextLink>
      </div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="">{/* empty */}</div>
      <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
      <div className="">{/* empty */}</div>
      {/* row */}
      <div className="dotted-h col-span-3 border-b">{/* empty */}</div>
    </section>
  );
};
